import React from 'react';
import { CellRendererParams } from 'routes/BudgetModule/config/types';
import EmailIcon from '@mui/icons-material/Email';
import Flex from 'ui/Flex/Flex';
import { SimulationAgentData } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/helpers/types';

type Props = CellRendererParams<SimulationAgentData, string>;

const EnvelopeAgentCellRenderer = ({
    valueFormatted,
}: Props): React.ReactElement => (
    <Flex align="center">
        <EmailIcon style={{ fontSize: 16, marginRight: 8 }} />{' '}
        {valueFormatted ? valueFormatted.toUpperCase() : ''}
    </Flex>
);

export default EnvelopeAgentCellRenderer;
